module.exports = __webpack_public_path__ + "src/assets/img/b2b.1d891ead.jpg";